



















/* eslint-disable */
import Vue from "vue";
import * as PIXI from "pixi.js";
import { gsap } from "gsap";

export default Vue.extend({
	name: "Otuge",
	data: (): { app: any } => ({
		app: null,
	}),
	props: {
		inputText: String,
		otugeNum: Number,
	},
	methods: {
		routeTop() {
			this.$router.push({
				name: "Top",
			});
		},
	},
	mounted(): void {
		this.app = new PIXI.Application({
			transparent: true,
			antialias: true,
		});
		this.$el.appendChild(this.app.view);
		this.app.renderer.view.classList.add("canvas");
		this.app.renderer.view.style.position = "fixed";
		this.app.renderer.view.style.zIndex = "900";
		this.app.renderer.view.style.top = "0";
		if (window.innerWidth > 411 && window.innerWidth < 1025) {
			this.app.renderer.view.style.left = "10em";
		} else if (window.innerWidth > 1025) {
			this.app.renderer.view.style.left = "16em";
		}
		this.app.renderer.autoResize = true;
		this.app.renderer.resize(window.innerWidth, window.innerHeight);

		const textureUpSprite = PIXI.Texture.from(
			require("../assets/images/yajirushi_haikei2.png")
		);
		const textureDownSprite = PIXI.Texture.from(
			require("../assets/images/yajirushi_haikei1.png")
		);
		let upSprite = new PIXI.Sprite(textureUpSprite);
		upSprite.anchor.x = 0.5;
		upSprite.anchor.y = 0.5;
		upSprite.x = this.app.screen.width / 2;
		upSprite.y = this.app.screen.height / 2 - 80;
		upSprite.scale.x = 0.6;
		upSprite.scale.y = 0.6;
		this.app.stage.addChild(upSprite);

		let downSprite = new PIXI.Sprite(textureDownSprite);
		downSprite.anchor.x = 0.5;
		downSprite.anchor.y = 0.5;
		downSprite.x = this.app.screen.width / 2 + 40;
		downSprite.y = this.app.screen.height / 2 + 130;
		downSprite.scale.x = 0.6;
		downSprite.scale.y = 0.6;
		this.app.stage.addChild(downSprite);

		const displacementFilter = new PIXI.filters.DisplacementFilter(
			PIXI.Sprite.from(require("../assets/images/displacement.jpg"))
		);
		displacementFilter.scale.x = 50;
		displacementFilter.scale.y = 50;
		const blurFilter = new PIXI.filters.BlurFilter(3, 2);
		this.app.stage.filters = [displacementFilter];

		const render = (): void => {
			requestAnimationFrame(render);
			this.app.renderer.render(this.app.stage);
		};
		render();

		gsap.to(upSprite, {
			x: 100,
			y: 200,
			duration: 3,
			repeat: -1,
			yoyo: true,
			ease: "power2.inOut",
			stagger: {
				each: 0.2,
			},
		});

		gsap.to(downSprite, {
			x: 300,
			y: 300,
			duration: 1.3,
			repeat: -1,
			yoyo: true,
			ease: "power2.inOut",
			stagger: {
				each: 0.2,
			},
		});
	},
});
